export class EmployerRecord {
    TrackingInfo:string;
     PermissiblePurpose:string;
    EmployeeID: number;
    CustomerID:number;
    LocationID:number;
    LastName:string;
    FirstName:string;
    SSN:string;
    PayRate:any;
    Salary:any;
    HireDt:Date
    TerminationDt:Date;
    GrossAmt:any;
    RegularAmt:any;
    DoubleTimeAmt:any;
    OverTimeAmt:any;
    VacationAmt:any;
    BonusAmt:any;
    BereavementAmt:any;
    CommissionAmt:any;
    HolidayAmt:any;
    JuryDutyAmt:any;
    OtherEarningAmt:any;
    RetroactivepayAmt:any;
    AutoallowanceAmt:any;
    JobTitle:string;
    OTTempRateAmt:any;
    RegularTempRateAmt:any;
    TotalNet:any;
    Year:number
    CurrentAsOf:any;
    EligibilityForRehire:boolean
    AdditionalNotes:string
    EmployerDisclaimer:string
    Legalesse:string;

}